import React, { useContext } from 'react';
import ReactDOM from 'react-dom';
import propTypes from 'prop-types';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import ConfirmDialog from 'chameleon/packages/blue-book-player/library/modal/ConfirmDialog';
import { MODAL_INNER_ROOT } from 'chameleon/packages/blue-book-player/constants/selectors';
import useGetPlayerEl from 'chameleon/packages/blue-book-player/hooks/useGetPlayerEl';
import { BluebookContext } from 'chameleon/packages/blue-book-player/state/BluebookContext';
import {
  SET_IS_SUBMIT_MODAL_VISIBLE,
  SET_IS_SUBMIT_TIMEOUT_MODAL_VISIBLE_ONCE,
} from 'chameleon/packages/blue-book-player/state/reducer';
import { learnosityExitPlayer } from 'chameleon/packages/blue-book-player/utility/learnosityUtils/submit';

const TimeoutModal = (props) => {
  const { onClose, allowHardTimerFF, router, location, params } = props;
  const state = location ? location.state : null;
  const subject = params ? params.subject : null;
  const { dispatch, state: playerState } = useContext(BluebookContext);
  const {
    isSubmitTimeOutModalVisble = false,
    isAutoSubmittedByTimer = false,
    isSubmitTimeOutModalVisbleOnce,
  } = playerState || {};
  const playerEl = useGetPlayerEl();
  const handleClose = () => {
    onClose();
    dispatch({ type: SET_IS_SUBMIT_TIMEOUT_MODAL_VISIBLE_ONCE, payload: true });
    if (isAutoSubmittedByTimer) {
      learnosityExitPlayer(subject, router, state);
    }
  };

  const onSubmit = () => {
    dispatch({ type: SET_IS_SUBMIT_MODAL_VISIBLE, payload: true });
    handleClose();
  };

  if (
    (isSubmitTimeOutModalVisbleOnce || !isSubmitTimeOutModalVisble) &&
    !isAutoSubmittedByTimer
  ) {
    return null;
  }

  const isHardTimer = playerState?.assignment?.isHardTimer;

  return ReactDOM.createPortal(
    <ConfirmDialog
      title="Time is up!"
      onClose={handleClose}
      onSuccess={handleClose}
      onSecondaryBtnClick={onSubmit}
      aria={{
        'aria-live': 'polite',
      }}
      content={{
        btnPrimary: isAutoSubmittedByTimer ? 'OK' : 'Continue',
        btnSecondary: isAutoSubmittedByTimer ? null : 'Submit Now',
      }}
    >
      {allowHardTimerFF ? (
        isHardTimer ? (
          <p>The timer has expired and your quiz has been submitted.</p>
        ) : (
          <p>
            You can submit your assignment now or continue working for as long
            as your teacher leaves the assignment unlocked.
          </p>
        )
      ) : (
        <p>
          You can submit your assessment now or continue working for as long as
          your teacher leaves the assessment unlocked.
        </p>
      )}
    </ConfirmDialog>,
    playerEl?.querySelector(MODAL_INNER_ROOT),
  );
};

TimeoutModal.propTypes = {
  onClose: propTypes.func,
};

TimeoutModal.defaultProps = {
  onClose: () => {},
};

export default compose(withRouter)(TimeoutModal);
